// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

const PROD_MODE = process.env.NODE_ENV === "production";
const NOOP = (..._input: any[]) => {}; // eslint-disable-line
const PREFIX = "NBO";

const DATE_FORMAT = ((formatter: Intl.DateTimeFormat) => {
  return (date: Date) => {
    return formatter.format(date);
  };
})(
  new Intl.DateTimeFormat("fr-FR", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  })
);

const color = (level: string) => {
  let levelColor = "black";
  switch (level) {
    case "debug":
      levelColor = "DarkMagenta";
      break;
    case "info":
      levelColor = "DarkGreen";
      break;
    case "log":
      levelColor = "DarkBlue";
      break;
    case "warn":
      levelColor = "DarkOrange";
      break;
    case "error":
      levelColor = "DarkRed";
      break;
    case "exception":
      levelColor = "Crimson";
      break;
    case "trace":
      levelColor = "DarkOrchid";
      break;
  }
  return levelColor;
};

const logMessage = (level: string, message?: any) => {
  return [
    `%c[${PREFIX}][${DATE_FORMAT(new Date())}][${level
      .toUpperCase()
      .padStart(5, " ")}]%c - ${message}`,
    `color: ${color(level)}; background-color: #D0D0D0`,
    "color: auto; background-color: auto"
  ];
};

export default {
  assert: PROD_MODE
    ? NOOP
    : (condition?: boolean, message?: string, ...data: any[]): void => {
        console.assert && console.assert(condition, message, data);
      },
  clear: PROD_MODE
    ? NOOP
    : (): void => {
        console.clear && console.clear();
      },
  count: PROD_MODE
    ? NOOP
    : (label?: string): void => {
        console.count && console.count(label);
      },
  debug: PROD_MODE
    ? NOOP
    : (message?: any, ...optionalParams: any[]) => {
        console.debug &&
          console.debug(...logMessage("debug", message), ...optionalParams);
      },
  dir: PROD_MODE
    ? NOOP
    : (value?: any, ...optionalParams: any[]): void => {
        console.dir && console.dir(value, ...optionalParams);
      },
  dirxml: PROD_MODE
    ? NOOP
    : (value: any): void => {
        console.dirxml && console.dirxml(value);
      },
  error: PROD_MODE
    ? NOOP
    : (message?: any, ...optionalParams: any[]): void => {
        console.error &&
          console.error(...logMessage("error", message), ...optionalParams);
      },
  // exception: PROD_MODE
  //   ? NOOP
  //   : (message?: string, ...optionalParams: any[]): void => {
  //       console.exception &&
  //         console.exception(
  //           ...logMessage("exception", message),
  //           ...optionalParams
  //         );
  //     },
  group: PROD_MODE
    ? NOOP
    : (groupTitle?: string, ...optionalParams: any[]): void => {
        console.group && console.group(groupTitle, ...optionalParams);
      },
  groupCollapsed: PROD_MODE
    ? NOOP
    : (groupTitle?: string, ...optionalParams: any[]): void => {
        console.groupCollapsed &&
          console.groupCollapsed(groupTitle, ...optionalParams);
      },
  groupEnd: PROD_MODE
    ? NOOP
    : (): void => {
        console.groupEnd && console.groupEnd();
      },
  info: PROD_MODE
    ? NOOP
    : (message?: any, ...optionalParams: any[]): void => {
        console.info &&
          console.info(...logMessage("info", message), ...optionalParams);
      },
  log: PROD_MODE
    ? NOOP
    : (message?: any, ...optionalParams: any[]): void => {
        console.log &&
          console.log(...logMessage("log", message), ...optionalParams);
      },
  markTimeline: PROD_MODE
    ? NOOP
    : (label?: string): void => {
        console.timeStamp && console.timeStamp(label);
      },
  profile: PROD_MODE
    ? NOOP
    : (reportName?: string): void => {
        console.profile && console.profile(reportName);
      },
  profileEnd: PROD_MODE
    ? NOOP
    : (reportName?: string): void => {
        console.profileEnd && console.profileEnd(reportName);
      },
  table: PROD_MODE
    ? NOOP
    : (...tabularData: any[]): void => {
        console.table && console.table(tabularData);
      },
  time: PROD_MODE
    ? NOOP
    : (label?: string): void => {
        console.time && console.time(label);
      },
  timeEnd: PROD_MODE
    ? NOOP
    : (label?: string): void => {
        console.timeEnd && console.timeEnd(label);
      },
  timeStamp: PROD_MODE
    ? NOOP
    : (label?: string): void => {
        console.timeStamp && console.timeStamp(label);
      },
  timeline: PROD_MODE
    ? NOOP
    : (label?: string): void => {
        console.time && console.time(label);
      },
  timelineEnd: PROD_MODE
    ? NOOP
    : (label?: string): void => {
        console.timeEnd && console.timeEnd(label);
      },
  trace: PROD_MODE
    ? NOOP
    : (message?: any, ...optionalParams: any[]): void => {
        console.trace &&
          console.trace(...logMessage("trace", message), ...optionalParams);
      },
  warn: PROD_MODE
    ? NOOP
    : (message?: any, ...optionalParams: any[]): void => {
        console.warn &&
          console.warn(...logMessage("warn", message), ...optionalParams);
      }
};
